export type RecurrencePeriod = "everyday" | "everyweek" | "everymonth"

export const recurrencePeriodTranslations: Record<RecurrencePeriod, string> = {
   everyday: "jour",
   everyweek: "semaine",
   everymonth: "mois",
}

